import React from 'react'
import AddNewSupplier from './AddSupplier/AddNewSupplier'

const Supplier = () => {
  return (
    <div className='flex flex-col gap-4 px-10'>
        
        <AddNewSupplier />
    </div>
  )
}

export default Supplier